import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
/** Fora da tela, dentro da arvore de acessibilidade. */
const ROTULO_OCULTO = {
    position: "absolute",
    width: 1,
    height: 1,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    whiteSpace: "nowrap",
};
export function FilterBar({ onSearchChange, searchValue, searchPlaceholder = "Pesquisar...", searchLabel, onReset, onExport, actions, exactMatch, onExactMatchChange, layout = "empilhado", larguraBusca = 420, resetLabel = "↻ REINICIAR FILTROS", resetActive = false, children, }) {
    const idBusca = useId();
    const emLinha = layout === "linha";
    return (_jsxs("section", { style: {
            background: "linear-gradient(180deg, rgba(16,185,129,.06), rgba(16,185,129,.02))",
            border: "1px solid var(--border)",
            borderRadius: 12,
            padding: 16,
            display: "flex",
            flexDirection: "column",
            gap: 12,
        }, children: [_jsxs("div", { style: { display: "flex", gap: 10, alignItems: "center", flexWrap: emLinha ? "wrap" : "nowrap" }, children: [onSearchChange ? (_jsxs(_Fragment, { children: [_jsx("label", { htmlFor: idBusca, style: ROTULO_OCULTO, children: searchLabel ?? searchPlaceholder }), _jsx("input", { id: idBusca, type: "search", placeholder: searchPlaceholder, value: searchValue ?? "", onChange: (e) => onSearchChange(e.target.value), style: {
                                    flex: emLinha ? "1 1 260px" : 1,
                                    maxWidth: emLinha ? larguraBusca : undefined,
                                    background: "transparent",
                                    border: "1px solid var(--border-strong)",
                                    borderRadius: 10,
                                    padding: "10px 14px",
                                    color: "var(--text)",
                                    fontSize: 14,
                                    outline: "none",
                                } })] })) : null, onExactMatchChange ? (_jsxs("label", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "var(--text-muted)", whiteSpace: "nowrap" }, children: [_jsx("input", { type: "checkbox", checked: exactMatch, onChange: (e) => onExactMatchChange(e.target.checked) }), "Pesquisar termo exato"] })) : null, emLinha ? (_jsx("div", { style: { marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }, children: children })) : null] }), emLinha ? null : children, _jsxs("div", { style: { display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }, children: [actions, _jsxs("div", { style: { marginLeft: "auto", display: "flex", gap: 8 }, children: [onReset ? (_jsx("button", { type: "button", onClick: onReset, style: resetActive ? btnGhostAtivo : btnGhost, children: resetLabel })) : null, onExport ? (_jsx("button", { type: "button", onClick: onExport, style: btnGhost, children: "\u2B07 EXPORTAR DADOS" })) : null] })] })] }));
}
const btnGhost = {
    padding: "8px 14px",
    borderRadius: 8,
    border: "1px solid var(--border-strong)",
    background: "transparent",
    color: "var(--text)",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: "0.05em",
    cursor: "pointer",
};
/** Mesmo botão, com o realce de "ativo" que `FilterChips`/`FiltroPill` usam —
 *  sinaliza "há filtro aplicado" sem fazer o botão em si aparecer/sumir. */
const btnGhostAtivo = {
    ...btnGhost,
    border: "1px solid var(--accent)",
    background: "color-mix(in srgb, var(--accent) 16%, transparent)",
    fontWeight: 700,
};
export function FilterCheckboxGroup({ options, selected, onChange }) {
    return (_jsx("div", { style: { display: "flex", gap: 16, flexWrap: "wrap" }, children: options.map((o) => {
            const isOn = selected.has(o.value);
            return (_jsxs("label", { style: { display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "var(--text-muted)", cursor: "pointer" }, children: [_jsx("input", { type: "checkbox", checked: isOn, onChange: () => {
                            const next = new Set(selected);
                            if (isOn)
                                next.delete(o.value);
                            else
                                next.add(o.value);
                            onChange(next);
                        } }), o.label] }, o.value));
        }) }));
}
//# sourceMappingURL=FilterBar.js.map